export default __webpack_public_path__ + "static/media/crêpe.0f653758.jpg";